import { app_configs } from "../services/configs";

const { fileServer} = app_configs;

export const formatImageUrl = (uri) => {
    if(window.location.origin === 'http://localhost:3000') {
        return `${fileServer}/${uri}`
    }
    return `${fileServer}/${uri}`
};